import React from 'react';
import { useSelector } from 'react-redux';
import { MinimizedCard } from './MinimizedCard';


const MinimizedCardDockDesktop = () => {
    // Get minimized cards from Redux store
    const minimizedCards = useSelector(state => state.minimized_card.minimizedCards);

    // Render a list of MinimizedCard components or a fallback message
    const renderMinimizedCards = () => {
        if (!minimizedCards || minimizedCards.length === 0) {
            return null;
        }

        const clonedCards = [...minimizedCards];

        return clonedCards.reverse().map(data => (
            <MinimizedCard key={data.id} card={data.content_group} workspace={data.workspace} />
        ));
    };

    return (
        <div className='minimize-card-dock-container d-none d-lg-block'>
            {
                minimizedCards.length > 0 && (
                    <div className="minimize-card-dock d-flex flex-row-reverse my-2 px-3">
                        {renderMinimizedCards()}
                    </div>
                )
            }

        </div>

    );
};

export { MinimizedCardDockDesktop };